import { takeEvery, put, call, select } from "redux-saga/effects";

import * as action from "./actions";
import * as api from "../../apis";
import moment from "moment";
import { getUserContext } from "./selectors";
import { currentMerchantName } from "../Merchant/selectors";
import { sendGAEvent } from "../common/google_analytics";

export function* watchLogin() {
  yield takeEvery(action.USER_LOGIN, login);
}

export function* watchLogout() {
  yield takeEvery(action.USER_LOGOUT, logout);
}

export function* login() {
  try {
    let response = yield call(api.login);

    yield put(action.userLoginSuccess(response));

    const userContext = yield select(getUserContext);
    const merchantName = yield select(currentMerchantName);
    sendGAEvent("User", "Login", merchantName, userContext);

    // After login send request for flyer runs to test endpoint. Only do this for
    // users that have the correct permission and are not admins.
    const permissions = response.permissions;

    if (permissions && permissions.access_marketplace_dashboard) {
      const merchantPermissions =
        response.permissions.access_marketplace_dashboard.Merchant;

      if (Array.isArray(merchantPermissions)) {
        const merchantId = merchantPermissions[0];

        if (merchantId && merchantId.length > 0) {
          try {
            const endDate = moment().format("YYYY-MM-DD");
            const startDate = "2017-01-01";
            const request = {
              merchant_id: merchantId,
              start_date: startDate,
              end_date: endDate
            };
            const response = yield call(api.fetchPublications, request);
            sendGAEvent(
              "User",
              `Test Flyer Runs: ${response.length}`,
              merchantName,
              userContext
            );
          } catch (e) {
            console.error(e);
            sendGAEvent(
              "User",
              "Test Flyer Runs: Endpoint Failed",
              merchantName,
              userContext
            );
          }
        }
      }
    }
  } catch (e) {
    yield put(action.userLoginFailure());
  }
}

export function* logout() {
  try {
    yield call(api.logout);
  } catch (e) {
    yield put(action.userLogoutFailure());
  }
}



// WEBPACK FOOTER //
// ./client/modules/User/sagas.ts